<template>
    <FormSection :application-id="Number(referral.application)">
        <template #content>
            <div class="d-flex mx-lg-n4 py-2">
                <div v-if="!isLoading">
                    <section class="col-12 offset-lg-1 col-lg-10 row g-0">
                        <div class="form-group col-12 col-lg-5 pe-lg-2">
                            <label for="auth-contact-first-name">
                                First Name
                                <span class="text-danger">*</span>
                            </label>
                            <input
                                name="auth-contact-first-name"
                                class="form-control"
                                maxlength="50"
                                type="text"
                                placeholder="Enter First Name"
                                v-model="contact.firstName"
                                :disabled="!isEditable"
                                :class="`${!v$.contact.firstName.$error ? '' : 'field-invalid'}`"
                                @blur="v$.contact.firstName.$touch"
                            />
                            <span v-if="v$.contact.firstName.$error" class="field-invalid"
                                >First name is required.</span
                            >
                        </div>
                        <div class="form-group col-4 col-lg-2 pe-lg-2">
                            <label for="referral-middle-initial"> Middle Initial </label>
                            <input
                                name="referral-middle-initial"
                                class="form-control"
                                maxlength="1"
                                type="text"
                                placeholder="Enter M.I."
                                v-model="contact.mi"
                            />
                        </div>
                        <div class="form-group col-12 col-lg-5 pe-lg-2">
                            <label for="auth-contact-last-name">
                                Last Name
                                <span class="text-danger">*</span>
                            </label>
                            <input
                                name="auth-contact-last-name"
                                class="form-control"
                                maxlength="50"
                                type="text"
                                placeholder="Enter Last Name"
                                v-model="contact.lastName"
                                :disabled="!isEditable"
                                :class="`${!v$.contact.lastName.$error ? '' : 'field-invalid'}`"
                                @blur="v$.contact.lastName.$touch"
                            />
                            <span v-if="v$.contact.lastName.$error" class="field-invalid">Last name is required.</span>
                        </div>
                        <div class="w-100"></div>
                        <div class="form-group col-12 col-lg-5 pe-lg-2">
                            <label for="auth-contact-relationship">
                                Relation to Referral
                                <span class="text-danger">*</span>
                            </label>
                            <!-- validate -->
                            <select
                                class="form-select"
                                name="relationship"
                                v-model="contact.relationship"
                                :disabled="!isEditable"
                                :class="`${!v$.contact.relationship.$error ? '' : 'field-invalid'}`"
                                @blur="v$.contact.relationship.$touch"
                            >
                                <option :value="null">Select Relationship</option>
                                <option
                                    v-for="[key, value] in enumToMap(RelationToReferral)"
                                    :key="key"
                                    :value="value.value"
                                >
                                    {{ value.name }}
                                </option>
                            </select>
                            <span v-if="v$.contact.relationship.$error" class="field-invalid"
                                >Relationship is required.</span
                            >
                        </div>
                        <div class="w-100"></div>
                        <div class="col-12 form-group d-flex">
                            <div class="me-2 mt-2">
                                <button class="btn btn-xs btn-primary mb-2" @click="setAddressToPrimaryAddress()">
                                    Use Referral's Address
                                </button>
                            </div>
                        </div>
                    </section>
                    <section class="col-12 offset-lg-1 col-lg-10 row g-0">
                        <ReferralAddressForm
                            v-model:address="contact.address"
                            :application="referral.application"
                            :account-id="referral.accountId"
                            :is-primary-address="true"
                            v-on:updateAddressDetails="updateAddressDetails"
                            v-on:updateAddressCountry="updateAddressCountry"
                            v-on:updateAddressState="updateAddressState"
                            ref="address"
                        />
                    </section>
                    <section class="col-12 offset-lg-1 col-lg-10 row g-0">
                        <div class="form-group col-12 col-lg-4 pe-lg-2">
                            <label for="auth-contact-primary-number">
                                Primary Phone <span class="text-danger">*</span></label
                            >

                            <PhoneNumber
                                :enable-country="true"
                                :phone-type-options="phoneNumberOptions"
                                v-model:value="contact.phoneNumbers[primaryNumberIndex(contact.phoneNumbers)].number"
                                v-model:extension="
                                    contact.phoneNumbers[primaryNumberIndex(contact.phoneNumbers)].extension
                                "
                                v-model:type="contact.phoneNumbers[primaryNumberIndex(contact.phoneNumbers)].type"
                                v-model:country="contact.phoneNumbers[primaryNumberIndex(contact.phoneNumbers)].country"
                                :disabled="!isEditable"
                                v-number-only
                            />
                        </div>
                        <div class="form-group col-12 col-lg-4 pe-lg-2">
                            <label for="auth-contact-alternate-number"> Fax Number </label>
                            <PhoneNumber
                                :enable-country="true"
                                :phone-type-options="phoneNumberOptions"
                                v-model:value="
                                    contact.phoneNumbers[alternativeNumberIndex(contact.phoneNumbers)].number
                                "
                                v-model:extension="
                                    contact.phoneNumbers[alternativeNumberIndex(contact.phoneNumbers)].extension
                                "
                                v-model:type="contact.phoneNumbers[alternativeNumberIndex(contact.phoneNumbers)].type"
                                v-model:country="
                                    contact.phoneNumbers[alternativeNumberIndex(contact.phoneNumbers)].country
                                "
                                :disabled="!isEditable"
                                v-number-only
                            />
                        </div>
                        <div class="form-group col-12 col-lg-4 pe-lg-2">
                            <label for="auth-contact-email"> E-mail Address </label>
                            <input
                                name="auth-contact-email"
                                class="form-control"
                                maxlength="50"
                                type="text"
                                placeholder="Enter Email"
                                v-model="contact.email"
                                :disabled="!isEditable"
                            />
                        </div>
                    </section>
                </div>
                <div class="p-5 w-100 d-flex flex-column text-center text-primary" v-if="isLoading">
                    <i class="far fa-save fa-7x me-2 animated slow flash infinite"></i>
                    <span class="mt-1 big-text">
                        <b>Save Contact In Progress...</b>
                    </span>
                </div>
            </div>
        </template>
    </FormSection>
</template>

<script lang="ts" src="./EmergencyContactsForm.ts"></script>
